import * as dealInfoHelpers from 'shared/utils/deal-info-helpers';

import commonTranslations from 'shared/translations/overlay-common-translations';


export default function getTranslationData(channel) {
  return {
    props: commonTranslations.getSubscription,
    priceModel: dealInfoHelpers.getSubscriptionPriceInfo(channel.dealInfo),
  };
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/components/player-overlay/ui-selectors/channel-overlay/paid-access/translation-data.js